import React from 'react'
import PropTypes from 'prop-types'
import Accordion from '../../../components/Accordion/Accordion'

const Row = ({ children }) => {
    return (
        <div className="w-full h-auto flex flex-row items-center justify-between">
            {children}
        </div>
    )
}

Row.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.element,
        PropTypes.object,
    ]),
}

const EquipmentInformation = ({ equipment, open, setOpen }) => {
    const renderContent = () => {
        return (
            <div className="w-full h-auto flex flex-col mt-4 gap-y-1">
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Equipment Category:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.showType || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Manufacturer:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.brand || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Fuel Type:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.showFuelType || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Year:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.constructionYear || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Model:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.model || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Serial:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.serialNumber || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Hours:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.meterReading || '-'}
                    </p>
                </Row>
            </div>
        )
    }

    const onIsOpen = () => {
        setOpen('equipmentInformation')
    }

    return (
        <Accordion
            text="Equipment Information"
            hasBorder={true}
            content={renderContent()}
            isEquipmentInfo
            onIsOpen={onIsOpen}
            forceClose={open}
        />
    )
}

EquipmentInformation.propTypes = {
    equipment: PropTypes.object,
    open: PropTypes.bool,
    setOpen: PropTypes.func,
}

export default EquipmentInformation
